import { Masonry } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import CurriculumContainer from "../../components/CurriculumContainer";
import Constants from "../../data/Constants";
import { getCurriculumList } from "../../services/curriculum.service";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import { AiOutlinePlus } from "react-icons/ai";

function Curriculum(props) {
  const [data, setData] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();
  const [updateView, forceUpdateView] = useState(0); // force the value to rerender

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getCurriculumList();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [updateView, isRefreshed]);

  return (
    <Masonry columns={isMobile ? 1 : undefined} spacing={2}>
      {data &&
        data.map((cr, index) => {
          return <CurriculumContainer key={index} curriculum={cr} />;
        })}

      <Link to="edit">
        <div className=" bg-secondary p-3 rounded-lg h-20 items-center flex justify-center text-gray-800 text-sm font-extrabold hover:bg-secondaryDark   cursor-pointer transition-all">
          Create New
          <AiOutlinePlus className="mx-2" color="black" />
        </div>
      </Link>
    </Masonry>
  );
}

export default Curriculum;
